import React from "react";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  existingCostCenter: server.dto.CostCenter
}

const CostCenterOptionsPanel = (props: Props) => {
  return <>
    <GeneralOptionsPanel
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }
      ]}
      data={props.optionsPanelData}
    />
  </>;
};

export default CostCenterOptionsPanel;